import * as React from 'react';
import { Image, Label } from '@cian/ui-kit';

import { SuperAgentTooltip } from '../SuperAgentTooltip';
import img from '../../assets/star24.svg';

export interface ISuperAgentLabelProps {
  levelName?: string;
}

export const SuperAgentLabel: React.FC<React.PropsWithChildren<ISuperAgentLabelProps>> = () => {
  return (
    <SuperAgentTooltip isOnlyDesktop>
      <Label icon={<Image width={16} height={16} src={img} />} background={'#ebf9e6'} color={'#34ac0a'}>
        Cуперагент
      </Label>
    </SuperAgentTooltip>
  );
};

SuperAgentLabel.displayName = 'SuperAgentLabel';
